import { CardPaper } from '../../shared/ui/card-paper';
import { ReactNode } from 'react';

export const FilterCard = ({ children }: { children: ReactNode }) => {
  return (
    <CardPaper sx={{ mb: 2 }}>
      {children}
    </CardPaper>
  );
};
